// extracted by mini-css-extract-plugin
export default {"divider":"Ws-z"};